export default __webpack_public_path__ + "static/media/1853.57975de7.png";